var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 5.49984V4.83317C13.3333 3.89975 13.3333 3.43304 13.1517 3.07652C12.9919 2.76292 12.7369 2.50795 12.4233 2.34816C12.0668 2.1665 11.6001 2.1665 10.6667 2.1665H9.33333C8.39991 2.1665 7.9332 2.1665 7.57668 2.34816C7.26308 2.50795 7.00811 2.76292 6.84832 3.07652C6.66667 3.43304 6.66667 3.89975 6.66667 4.83317V5.49984M8.33333 10.0832V14.2498M11.6667 10.0832V14.2498M2.5 5.49984H17.5M15.8333 5.49984V14.8332C15.8333 16.2333 15.8333 16.9334 15.5608 17.4681C15.3212 17.9386 14.9387 18.321 14.4683 18.5607C13.9335 18.8332 13.2335 18.8332 11.8333 18.8332H8.16667C6.76654 18.8332 6.06647 18.8332 5.53169 18.5607C5.06129 18.321 4.67883 17.9386 4.43915 17.4681C4.16667 16.9334 4.16667 16.2333 4.16667 14.8332V5.49984",
    stroke: "#475467",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.d2620489d3f1eaa99b202237684475cf.svg";
export { ForwardRef as ReactComponent };